import { Component, Input } from "@angular/core";
import libraryStore from "../../../services/stores/library.store";
import { Router } from "@angular/router";
import { NavigationItemModel } from "./navigationItem.model";
import { SearchService } from "../../../services/search.service";
import { SchedulerAsideService } from "../../scheduler/schedulerAside/scheduler-aside-service";
import { UI } from "../../../services/ui.service";

@Component({
  selector: "icn-sidebar-nav",
  templateUrl: "sidebar-nav.component.html",
  styleUrls: ["sidebar-nav.component.scss"],
})
export class SidebarNavComponent {
  libraryStore = libraryStore;

  @Input()
  items: NavigationItemModel[];

  constructor(
    private router: Router,
    private searchService: SearchService,
    private schedulerAsideService: SchedulerAsideService,
    private ui: UI,
  ) {}

  /**
   * Component Init
   * @return void
   */
  ngOnInit() {}

  /**
   * Return icon path
   * @param name
   * @returns {any}
   */
  getIcon(name) {
    return `/assets/icons/${name}.svg`;
  }

  /**
   * On Tab Click - Perform validation and decision about navigation
   * @param navigationItem
   */
  onTabClick(navigationItem: NavigationItemModel) {
    /* */
    if (this.schedulerAsideService.isCollapsed()) {
      this.schedulerAsideService.setCollapse(false);
      this.ui.EVENTS.MamCollapsed.next(false);
    }

    if (
      navigationItem.isNavigationNeeded() ||
      this.routeBackToScheduler(navigationItem)
    ) {
      this.searchService.searchMode = navigationItem.storeKey();
      this.searchService.subjectModeNext();
      return this.navigateAndLoad(
        navigationItem.navigationPath(),
        navigationItem.storeKey(),
      );
    }
    this.searchService.searchMode = navigationItem.storeKey();
    this.libraryStore.setLibraryType(navigationItem.storeKey());
    this.searchService.subjectModeNext();
  }

  /**
   * Provides functionally for redirecting and store loading
   * @param path
   * @param libraryType
   * @return
   */
  navigateAndLoad(path, libraryType) {
    this.router.navigate([path]);

    this.libraryStore.setLibraryType(libraryType);
  }

  /**
   * Return if type should be selected
   * @param type
   * @return boolean
   */
  isSelected(type) {
    if (type == libraryStore.getLibraryType()) {
      return true;
    }

    return false;
  }

  routeBackToScheduler(item: NavigationItemModel) {
    return false;
    /*const storeKey = item.storeKey();

        if (['media', 'graphics', 'live', 'video'].indexOf(storeKey) === -1) { return false; }

        if (this.router.url.includes('mam/editMedia') ||
            this.router.url.includes('graphics/new/') && !this.router.url.includes('scheduler') ||
            this.router.url.includes('/live') && storeKey === 'graphics') {
            item.setNavigationPath('/scheduler/calendar');
            return true;
        }
        return false;*/
  }
}
